export var TipoArquivoEnum;
(function (TipoArquivoEnum) {
    TipoArquivoEnum["PDF"] = "PDF";
    TipoArquivoEnum["PNG"] = "PNG";
    TipoArquivoEnum["JPEG"] = "JPEG";
    TipoArquivoEnum["DOC"] = "DOC";
    TipoArquivoEnum["ZIP"] = "ZIP";
})(TipoArquivoEnum || (TipoArquivoEnum = {}));
(function (TipoArquivoEnum) {
    var mapDescricao = new Map([
        [TipoArquivoEnum.PDF, 'PDF'],
        [TipoArquivoEnum.PNG, 'PNG'],
        [TipoArquivoEnum.JPEG, 'JPEG'],
        [TipoArquivoEnum.DOC, 'DOC'],
        [TipoArquivoEnum.ZIP, 'ZIP'],
    ]);
    var mapExtension = new Map([
        [TipoArquivoEnum.PDF, '.pdf'],
        [TipoArquivoEnum.PNG, '.png'],
        [TipoArquivoEnum.JPEG, '.jpeg'],
        [TipoArquivoEnum.DOC, 'application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword'],
        [TipoArquivoEnum.ZIP, 'application/zip, application/x-zip-compressed, multipart/x-zip'],
    ]);
    function getDescricao(key) {
        return mapDescricao.get(key);
    }
    TipoArquivoEnum.getDescricao = getDescricao;
    function getExtension(key) {
        return mapExtension.get(key);
    }
    TipoArquivoEnum.getExtension = getExtension;
    function getOptions() {
        var list = [];
        mapDescricao.forEach(function (label, value) {
            list.push({ label: label, value: value });
        });
        return list;
    }
    TipoArquivoEnum.getOptions = getOptions;
    function getAccpetExtensions(key) {
        if (key) {
            return getExtension(key);
        }
        else {
            var accept_1 = '';
            mapExtension.forEach(function (extension, value) {
                accept_1 += ", ".concat(extension);
            });
            return accept_1;
        }
    }
    TipoArquivoEnum.getAccpetExtensions = getAccpetExtensions;
})(TipoArquivoEnum || (TipoArquivoEnum = {}));
